module.exports = __webpack_public_path__ + "img/grap-lupe.ad0d8fe6.svg";